import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { Button } from '@repo/ui/Button';
import { Link } from '@repo/ui/Link';
import { useBranchedPageAction } from '@/features/shared/analytics/hooks/useBranchedPageAction';
import { ANALYTICS_ACTION_NAME, ANALYTICS_EXIT_INTENT_ACTION_SECTION } from './constants';
export function CTAs(t0) {
  const $ = _c(19);
  const {
    parentActivityId
  } = t0;
  let t1;
  if ($[0] !== parentActivityId) {
    t1 = {
      actionName: ANALYTICS_ACTION_NAME,
      actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
      actionType: "select",
      actionInput: "exit",
      parentActivityId
    };
    $[0] = parentActivityId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fireExitPageActionAnalyticsEvent = useBranchedPageAction(t1);
  let t2;
  if ($[2] !== parentActivityId) {
    t2 = {
      actionName: ANALYTICS_ACTION_NAME,
      actionSection: ANALYTICS_EXIT_INTENT_ACTION_SECTION,
      actionType: "select",
      actionInput: "return",
      parentActivityId
    };
    $[2] = parentActivityId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fireReturnPageActionAnalyticsEvent = useBranchedPageAction(t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      display: "flex",
      flexDirection: "column",
      gap: "3"
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== fireReturnPageActionAnalyticsEvent) {
    t4 = () => fireReturnPageActionAnalyticsEvent();
    $[5] = fireReturnPageActionAnalyticsEvent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = css({
      height: "[45px]",
      fontSize: "14px"
    });
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <Dialog.Close render={<Button onClick={t4} className={t5}>KEEP GOING</Button>} />;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== fireExitPageActionAnalyticsEvent) {
    t7 = () => fireExitPageActionAnalyticsEvent();
    $[10] = fireExitPageActionAnalyticsEvent;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = css({
      width: "[100%]",
      bg: "common.white",
      border: "[1px solid]",
      borderColor: "greens.main",
      height: "[45px]",
      fontSize: "14px",
      fontWeight: "semibold",
      cursor: "pointer",
      textStyle: "body",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      py: "3",
      px: "3.5",
      _hover: {
        bg: "neutral.lightest"
      }
    });
    t9 = {
      color: "greens.main"
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7) {
    t10 = <Link onClick={t7} href="https://www.nerdwallet.com/credit-cards/best" underline="none" className={t8} css={t9}>NO, THANKS</Link>;
    $[14] = t7;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t6) {
    t11 = <div className={t3}>{t6}{t10}</div>;
    $[16] = t10;
    $[17] = t6;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}